import React from 'react';
import {ACTION} from "../../costanti";
import PropTypes from 'prop-types';
import * as _ from "lodash";

import {dayJS} from "../../applicationConf";

const Giorni = (props) => {

    const handleCheckboxChange = ({target}) => {
        const {giorni, dataInizio, dataFine} = props;

        if (!giorni.giorni.includes(+target.value)) {

            target.parentNode.classList.add('btn-info', 'active');
            target.parentNode.classList.remove('btn-warning');
            giorni.giorni.push(+target.value);

        } else {
            target.parentNode.classList.add('btn-warning');
            target.parentNode.classList.remove('btn-info', 'active');
            giorni.giorni.splice(giorni.giorni.indexOf(+target.value), 1);
        }

        if (giorni.giorni.length === 0) {
            giorni.valid = false;
            document.getElementById('settimana').classList.add('invalid__border');
        }

        if (giorni.giorni.length === 1 && giorni.errori === 'Campo Obbligatorio') {
            giorni.valid = false;
            document.getElementById('settimana').classList.remove('invalid__border');
        }

        giorni.giorni.sort();

        checkGiorniConMese({
            giorni,
            dataInizio,
            dataFine,
            changeValueGiorni: props.changeValueGiorni
        });

    };

    /* RENDER */
    const renderGiorniCheckBox = () => {
        const arrGiorni = [1, 2, 3, 4, 5, 6, 7];

        if (!ACTION.includes(props.action)) {
            return arrGiorni.map((g) => {
                return (
                    <label key={`${g}_label`}
                           className={props.giorni.giorni.includes(g) ? 'btn btn-info active m-0' : 'btn btn-warning m-0'}>
                        <input key={`${g}_checkbox`}
                               style={{display: 'none'}}
                               type="checkbox"
                               value={g}
                               onClick={handleCheckboxChange}
                        />
                        {dayJS().isoWeekday(g).format('ddd')}
                    </label>
                );
            })
        } else {
            return arrGiorni.map((g) => {
                return (
                    <label key={`${g}_label`}
                           style={{cursor: 'not-allowed'}}
                           className={!props.giorni.giorni.includes(g) ? 'btn btn-info__disable' : 'btn btn-warning__disable'}>
                        <input key={`${g}_checkbox`}
                               style={{display: 'none'}}
                               type="checkbox"
                               value={g}
                               onClick={handleCheckboxChange}
                               disabled={ACTION.includes(props.action)}/>
                        {dayJS().isoWeekday(g).format('ddd')}
                    </label>
                );
            })
        }
    };

    return (
        <section className="d-flex flex-wrap flex-column">
            <section className="d-flex flex-wrap">
                <label style={{margin: '5px 0px'}}>Giorni</label>
                <span className="text-danger" style={{fontSize: '20px', marginLeft: '5px'}}>*</span>
            </section>
            <div id='settimana' className='btn-group'>
                {renderGiorniCheckBox()}
            </div>

            {typeof (props.giorni.errori) === 'object' ? <div>{props.giorni.errori.dataInizio}</div> :
                <div>{props.giorni.errori}</div>}

        </section>
    )
};

export default Giorni;

Giorni.propTypes = {
    giorni: PropTypes.shape({
        giorni: PropTypes.arrayOf(PropTypes.number).isRequired,
        errori: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
        valid: PropTypes.bool.isRequired
    }),
    dataFine: PropTypes.string.isRequired,
    dataInizio: PropTypes.string.isRequired,
    action: PropTypes.string
};

Giorni.defaultProps = {
    giorni: {
        giorni: [],
        errori: 'Campo Obbligatorio',
        valid: false
    },
    dataFine: '',
    dataInizio: ''
};

export const checkGiorniConMese = (props) => {
    const {giorni, dataInizio, dataFine} = props;
    const rangeGiorni = (dayJS(dataFine, 'YYYY-MM-DD').diff(dayJS(dataInizio, 'YYYY-MM-DD'), 'day')) + 1;

    if (props.dataFine !== '') {
        if (dayJS(dataInizio, 'YYYY-MM-DD').isSameOrBefore(dataFine)) {
            const nomeCompletoGiorniSelezinati = giorni.giorni.map(g => dayJS().isoWeekday(g).format('dddd'));

            const arrayDiConfronto = _.times(rangeGiorni, (g) => dayJS(dataInizio, 'YYYY-MM-DD').add(g, 'day').format('dddd'))
                .reduce((el1, el2) => {
                    el1.push(el2);
                    return el1
                }, []);

            if (giorni.giorni.length <= rangeGiorni) {
                if (nomeCompletoGiorniSelezinati.length > 0 &&
                    (nomeCompletoGiorniSelezinati.map(g => arrayDiConfronto.includes(g))
                        .reduce((val1, val2) => val1 && val2, true))
                ) {
                    document.getElementById('settimana').classList.remove('invalid__border');
                    giorni.valid = true;
                    giorni.errori = 'Campo Obbligatorio';
                } else {
                    giorni.valid = false;
                    giorni.errori = 'Date non congruenti con il range di date';
                    document.getElementById('settimana').classList.add('invalid__border');
                }
            } else {
                giorni.valid = false;
                giorni.errori = 'Numero di giorni non congruo con il range di date per la pianificazione';
                document.getElementById('settimana').classList.add('invalid__border');
            }

        } else {
            giorni.valid = false;
            giorni.errori = 'Attenzione la data di fine partecipazione deve essere successiva alla data di inizio';
            document.getElementById('settimana').classList.add('invalid__border');
        }
        props.changeValueGiorni(giorni);
    }
};


